import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import {Router} from '@angular/router'
import { AuthServiceService } from 'src/services/auth-service.service';


@Injectable({
  providedIn: 'root'
})

export class AuthGuardGuard implements CanActivate {

  constructor(
    private auth: AuthServiceService) { }

    canActivate(): boolean {
      if(this.auth.loggedin()) {
        return true;
      }
      else{
        this.auth.redirectToLogin();
        return false;
      }
    }
}


